import { MedicalItem } from "./MedicalItem";

class MedicalItemFamilyHistory extends MedicalItem {
    public Treatment: string;
    public Description: string;
    public SpecifiedRelationship: string;
    public Problem: string;
    public RelationshipLookupId: string;
    public RelationshipLookupValue: string;
}

export { MedicalItemFamilyHistory };
